export enum MessageViewPageType {
  Main = 'main',
  AllPins = 'allPins',
}
